import React from "react";
import BaseTrackVehicleList from "./BaseTrackVehicleList";
import { COMPANY_DOMAINS } from "@routebot/constants";

const TrackStudentVehicleList = () => {
  return <BaseTrackVehicleList mode={COMPANY_DOMAINS.STUDENT} />;
};

export default TrackStudentVehicleList;
